import { For, SimpleGrid } from "@chakra-ui/react";
import ShadowBox from "@/components/partials/ShadowBox";
import ShortBox from "@/components/ShortBox";
import revalidate from '@/lib/revalidate';

export default async function Short() {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/shorts`, {
    next: revalidate('REVALIDATE_HOME_SHORTS')
  });

  const result = await res.json();
  const { data: posts } = result;

  if(!posts || posts.length === 0) return;

  return (
    <ShadowBox text="Shorts">
      <SimpleGrid columns={{ base: 1, lg: 4 }}>
        <For each={posts}>
          {(item, key) => (
            <ShortBox key={key} item={item} />
          )}
        </For>
      </SimpleGrid>
    </ShadowBox>
  )
}
